module.exports = __webpack_public_path__ + "static/img/YCJ.80091d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YCJ.png
// module id = AmzK
// module chunks = 34